module.exports = __webpack_public_path__ + "static/media/bannar.cff506c4.jpg";